\<template>
    <div
        @click="onClick"
        class="ball-grid__ball-wrapper"
    >
        <span class="ball-grid__ball-number">{{ number }}</span>
        <i class="icon icon-close"/>
    </div>
</template>

<script>
    export default {
        name: 'LottoBetSlipBall',
        props: {
            number: {
                type: Number,
                required: true
            },
        },
        methods: {
            onClick() {
                this.$emit('removeNumberClick', this.number);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/lotto/betSlip/LottoBetSlipBall.vue